import { isFeatureFlagEnabled } from "../analytics/posthog";
import { FEATURE_FLAG_KEYS } from "../featureFlags/featureFlagKeys";
import { isIngressoFeatureEnabled } from "../featureFlags/ingressoFeature";
import { usePostHogFeatureFlag } from "./usePostHogFeatureFlag";

/** Reactive PostHog flag state for React surfaces. */
export const useIngressoEnabled = () => {
  const flag = usePostHogFeatureFlag(FEATURE_FLAG_KEYS.INGRESSO, false);
  return {
    isEnabled: isIngressoFeatureEnabled(flag.isEnabled),
    loading: flag.loading,
  };
};

/** Synchronous check for non-React code paths (fail closed). */
export const isIngressoEnabledSync = (): boolean =>
  isIngressoFeatureEnabled(
    isFeatureFlagEnabled(FEATURE_FLAG_KEYS.INGRESSO, false),
  );
